import React, { useState } from "react";

// Each location's Google Form share link.
const LOCATIONS = {
  houston: {
    label: "Houston, Texas",
    formSrc: "https://forms.gle/ft1L8CbCuPG1XpCB6",
  },
  garner: {
    label: "Garner, North Carolina",
    formSrc: "https://forms.gle/MZiwM2JkFyvnN1sS8",
  },
};

function Signup() {
  const [location, setLocation] = useState("houston");
  const active = LOCATIONS[location];

  return (
    <div style={pageStyle}>
      <section style={heroStyle}>
        <h1 style={heroTitle}>Sign Up</h1>
        <p style={heroSubtitle}>Choose your location to get started</p>

        <div style={toggleRow}>
          {Object.entries(LOCATIONS).map(([key, { label }]) => {
            const isActive = key === location;
            return (
              <button
                key={key}
                type="button"
                onClick={() => setLocation(key)}
                style={{
                  ...toggleButton,
                  ...(isActive ? toggleButtonActive : {}),
                }}
                aria-pressed={isActive}
              >
                {label}
              </button>
            );
          })}
        </div>

        <p style={heroLocation}>
          Showing the form for <strong>{active.label}</strong>
        </p>
      </section>

      <section style={sectionWrapperStyle}>
        <div style={formContainer}>
          <iframe
            key={location}
            title={`Sign up form - ${active.label}`}
            src={active.formSrc}
            width="100%"
            height="700"
            frameBorder="0"
            style={{ maxWidth: "760px", width: "100%" }}
          >
            Loading…
          </iframe>
        </div>
      </section>
    </div>
  );
}

const pageStyle = {
  fontFamily: "'Segoe UI', Arial, sans-serif",
  lineHeight: "1.6",
  color: "#222",
};

const heroStyle = {
  background: "linear-gradient(135deg, #dff7ea, #c8f0de)",
  textAlign: "center",
  padding: "70px 20px 50px",
};

const heroTitle = {
  fontSize: "3rem",
  marginBottom: "10px",
  color: "#155f4b",
};

const heroSubtitle = {
  fontSize: "1.4rem",
  marginTop: "10px",
};

const heroLocation = {
  fontSize: "1.1rem",
  marginTop: "16px",
  color: "#444",
};

const toggleRow = {
  display: "flex",
  gap: "12px",
  justifyContent: "center",
  flexWrap: "wrap",
  marginTop: "24px",
};

const toggleButton = {
  padding: "12px 24px",
  fontSize: "1rem",
  fontFamily: "inherit",
  borderRadius: "999px",
  border: "2px solid #155f4b",
  background: "#ffffff",
  color: "#155f4b",
  cursor: "pointer",
  transition: "all 0.15s ease",
};

const toggleButtonActive = {
  background: "#155f4b",
  color: "#ffffff",
};

const sectionWrapperStyle = {
  width: "100%",
  background: "#eafaf1",
};

const formContainer = {
  display: "flex",
  justifyContent: "center",
  padding: "40px 20px",
};

export default Signup;
